import { fetchAuthSession, signOut } from 'aws-amplify/auth';
import Axios from 'axios';
import { omitBy, isNil } from 'lodash-es';
import queryString from 'query-string';
import vuexStore from '@/store';

const httpClient = baseURL => async request => {
    try {
        let authHeaders = {};
        if (!request.noAuth) {
            const { tokens } = await fetchAuthSession();

            if (!tokens) {
                throw Error('Your authenticated session has expired');
            }

            authHeaders = {
                Authorization: `Bearer ${tokens.idToken}`,
                // TODO: rename it to "X-Quext-Profile-Id"
                'X-Customer-User-Id': vuexStore.getters['auth/profile']?.profileId,
                // TODO: use "X-Quext-Customer-Id" instead of "X-Quext-Customer"
                'X-Quext-Customer': vuexStore.getters['auth/profile']?.customerId,
                'X-Quext-Customer-Id': vuexStore.getters['auth/customerId'],
                'X-Quext-Community-Id': vuexStore.getters['auth/community']?.id,
            };
        }

        return Axios.request({
            ...request,
            baseURL,
            paramsSerializer: params => queryString.stringify(params),
            headers: omitBy(
                {
                    ...authHeaders,
                    ...request.headers,
                },
                isNil
            ),
        }).catch(error => {
            const response = error?.response;
            // Proxy response from RAA contains a string with a detailed error message in 'data' prop.
            const proxyResponse = typeof response?.data === 'string';
            let message = (proxyResponse && response?.data) || response?.data?.message || error.message;
            // Add unique traceId if there is no message
            if (!response?.data?.message) {
                const traceId = response?.headers['x-traceid'];
                message += `\n${traceId}`;
            }
            // Temporally commented
            // if (response?.status === 401) {
            //   await signOut();
            // }

            return Promise.reject({
                message,
                ...response,
            });
        });
    } catch (e) {
        await signOut();
        return Promise.reject(e);
    }
};

export default httpClient;
